export var Operator;
(function (Operator) {
    Operator["And"] = "AND";
    Operator["Or"] = "OR";
})(Operator || (Operator = {}));
